import { render, staticRenderFns } from "./LlBoardChecklistList.vue?vue&type=template&id=33c68422&scoped=true"
import script from "./LlBoardChecklistList.vue?vue&type=script&lang=js"
export * from "./LlBoardChecklistList.vue?vue&type=script&lang=js"
import style0 from "./LlBoardChecklistList.vue?vue&type=style&index=0&id=33c68422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c68422",
  null
  
)

export default component.exports